import { Box, Heading } from '@chakra-ui/react'
import React from 'react'
import { Line } from 'react-chartjs-2'

export default function DailyBalanceTrendChart({ reportData }) {

    const balanceByDate = reportData?.Transactions?.reduce((acc, curr) => {
        const date = curr.Date.split("T")[0];
        acc[date] = curr.Balance;
        return acc;
    }, {});

    const dates = balanceByDate && Object.keys(balanceByDate);
    const balances = balanceByDate && Object.values(balanceByDate);

    const chartData = {
        labels: dates,
        datasets: [
            {
                label: "Balance",
                data: balances,
                borderColor: "rgba(75, 192, 192, 1)",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                tension: 0.4,
                fill: true,
            },
        ],
    };

    const options = {
        responsive: true,
        layout: {
            padding: {
                right: 15
            }
        },
        legend: {
            display: true,
            onClick: function (e, legendItem) {
                e.preventDefault();
                e.stopPropagation();
            },
            position: 'bottom',
            labels: {
                fontFamily: "Poppins",
                fontColor: '#000',
                fontSize: 12,
                fontStyle: 'normal',
                usePointStyle: true,
                padding: 20,
            },
        },
        maintainAspectRatio: true,
        cutoutPercentage: 70,
        tooltips: {
            position: 'nearest',
            backgroundColor: 'rgba(255,255,255,1)',
            titleFontColor: '#000',
            bodyFontColor: '#000',
            titleFontSize: 14,
            titleFontFamily: "Poppins",
            bodyFontFamily: "Poppins",
            bodyFontSize: 14,
            bodySpacing: 4,
            xPadding: 12,
            yPadding: 12,
            borderColor: '#D3D2D5',
            borderWidth: 1,
            displayColors: false,
            callbacks: {
                title: function (tooltipItem, data) {
                    return data.labels[tooltipItem[0].index];
                },
                label: function (tooltipItem, data) {
                    const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    const formattedValue = value.toLocaleString('en-US');
                    return `(${'₹ ' + formattedValue + ''})`;
                }
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    fontColor: "#000",
                    fontSize: 12,
                    fontFamily: "Poppins",
                    // stepSize: 1,
                    // beginAtZero: true,
                    callback: function (value, index, values) {
                        return value.toLocaleString() + '';
                    }
                }
            }],
            xAxes: [{
                ticks: {
                    fontColor: "#000",
                    fontSize: 12,
                    fontFamily: "Poppins",
                }
            }],
        }
    };

    return (
        <Box className='investor_chart'>
            <Heading as="h2" className='font-poppins card_heading'>Daily Balance Trend</Heading>
            <Box mt={6}>
                <Line data={chartData} options={options} />
            </Box>
        </Box>
    )
}
